import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type QuestionsTemplate from 'modules/surveys/store/models/QuestionsTemplate'

import TemplateQuestionsList from './List'
import { QuestionsTemplateContextProvider } from './questionsTemplateContext'

interface Props {
  questionsTemplate: QuestionsTemplate
}

const QuestionsContent = ({ questionsTemplate }: Props) => {
  const title = i18n.t('app_store_v2.apps.performance_v2.settings.templates.new.questions_info')

  const description = i18n.t(
    'app_store_v2.apps.performance_v2.settings.templates.new.questions_description'
  )

  const questionsTemplateId = questionsTemplate.attributes.id

  return (
    <QuestionsTemplateContextProvider questionsTemplateId={questionsTemplateId}>
      <TemplateQuestionsList
        title={title}
        description={description}
        questionsTemplateId={questionsTemplateId}
      />
    </QuestionsTemplateContextProvider>
  )
}

export default observer(QuestionsContent)
